var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fa-icon row-center",class:[_vm.icon.placement, _vm.icon.alignment, _vm.icon.classes],style:({ fontSize: _vm.icon.size }),attrs:{"data-cy":"c-icon-cy"}},[_c('img',{staticClass:"base-color-filter1",style:({ height: _vm.icon.size }),attrs:{"src":_vm.icon.url,"alt":_vm.icon.altText}})])
}
var staticRenderFns = []

export { render, staticRenderFns }